import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import React, { memo } from "react";
import { GridBox, Link, Ul } from "@pochta/ui";
import filterAndHalve from "../helpers/halve";

var FooterListFiltered = function FooterListFiltered(_ref) {
  var _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      _ref$isFirstPart = _ref.isFirstPart,
      isFirstPart = _ref$isFirstPart === void 0 ? false : _ref$isFirstPart;
  return /*#__PURE__*/React.createElement(GridBox, {
    xs: 12,
    sm: 6,
    xl: 6
  }, /*#__PURE__*/React.createElement(Ul, {
    listStyleType: "none",
    size: "s"
  }, filterAndHalve(list, isFirstPart).map(function (item) {
    return /*#__PURE__*/React.createElement(Ul.Li, {
      key: item.title
    }, /*#__PURE__*/React.createElement(Link, {
      underline: "none",
      color: "inherit",
      href: item.link
    }, item.title));
  })));
};

export default /*#__PURE__*/memo(FooterListFiltered);